import React from "react";

export const Toggle = ({
  name,
  title,
  text,
  isSelected,
  onChange,
}: {
  name: string;
  text: string;
  title?: string;
  isSelected: boolean;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
}) => (
  <label
    htmlFor={name}
    title={title}
    className="mt-3 w-64 flex items-center cursor-pointer mr-2"
  >
    <span className="relative">
      <span
        className={`${
          isSelected ? "bg-green-400" : "bg-gray-400"
        } block w-10 h-6 rounded-full`}
      ></span>
      <span
        className={`${
          isSelected ? "translate-x-full" : ""
        } absolute block w-4 h-4 mt-1 ml-1 rounded-full inset-y-0 left-0 focus-within:shadow-outline transition-transform duration-300 ease-in-out bg-white transform`}
      >
        <input
          id={name}
          name={name}
          type="checkbox"
          onChange={onChange}
          checked={isSelected}
          className="absolute opacity-0 w-0 h-0"
        />
      </span>
    </span>
    <span className="ml-3 text-sm">{text}</span>
  </label>
);
